export const hideUsernameError = () => {
	const messageErrEl = document.getElementById('message-error');
	const suggestionContainerEl = document.getElementById('suggestion-container');
	messageErrEl.closest('div').classList.add('hidden');
	// suggestion container reset to hidden
	suggestionContainerEl.classList.add('hidden');
}
